import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { FinancingDetailPage } from './FinancingDetailPage';
import { CostsPage } from './CostsPage';
import { FinancingPage } from './FinancingPage';
import { ProjectDetailPage } from './ProjectDetailPage';
import { ProjectsPage } from './ProjectsPage';

/**
 * Einstiegspunkt des Moduls Finanzierungen und Leasings im Backoffice (KON-253, Schlüssel `financing`, siehe docs/finanzierungen.md): Verträge mit Zahlungsplan, Vorschau und Vertragsdokumenten
 * unter /finanzierungen. Dazu seit KON-256 Vorhaben mit Tragfähigkeit und Mappe für die Bank (/finanzierungen/vorhaben) und die Kostenstruktur (/finanzierungen/kosten). Die Zahlen fließen in den Finanzreport und die Auswertungen ein.
 */
export const financingModule: BackofficeModule = {
  key: 'financing',
  path: '/finanzierungen',
  routes: (
    <>
      <Route path="finanzierungen" element={<ModuleGate module="financing" permission="financing.read"><FinancingPage /></ModuleGate>} />
      <Route path="finanzierungen/vorhaben" element={<ModuleGate module="financing" permission="financing.read"><ProjectsPage /></ModuleGate>} />
      <Route path="finanzierungen/vorhaben/:id" element={<ModuleGate module="financing" permission="financing.read"><ProjectDetailPage /></ModuleGate>} />
      <Route path="finanzierungen/kosten" element={<ModuleGate module="financing" permission="financing.read"><CostsPage /></ModuleGate>} />
      <Route path="finanzierungen/:id" element={<ModuleGate module="financing" permission="financing.read"><FinancingDetailPage /></ModuleGate>} />
    </>
  ),
};
